import React from "react";
const FireCompliance = ({ isShow, setValue, watch }) => {
    return (
        <>
            <div
                className=" d-flex mt-3"
                key={`checkbox-survey-child`}
            >
                <div className="mr-2">
                    <label class="custom-checkbox-large">
                        <input
                            type="checkbox"
                            // id={`assign-checkbox-${params.row.job_id}`}
                            // key={`assign-checkbox-${params.row.job_id}`}
                            // onClick={onChange}
                            // defaultChecked={
                            //   inspector ? inspector == jobInspector : false
                            // }
                            // checked={inspector ? inspector == jobInspector : false}
                            disabled={isShow}
                            checked={watch("fire_safety_required") == false ? true : false}
                            onChange={(e) => setValue("fire_safety_required",  e.target.checked == true ? false : null )}
                        />
                        <span class="checkmark-large"></span>
                    </label>

                </div>
                <div>
                    <p className="eng-language-600"> I hereby certify that the Fire Safety Notice provided by the building owner*HAS* been
                        posted and is being maintained on the inside of the main entrance door to my
                        apartment. I understand false statements are punishable by law.</p>
                    <p className="span-language">  Por la presente certifico que el Aviso de Seguridad contra Incendios proporcionado
                        por el propietario del edificio HA sido colocado y se mantiene en el interior de la
                        puerta principal de entrada a mi apartamento. Entiendo que las declaraciones falsas
                        son castigadas por la ley.</p>
                </div>
            </div>
            <div
                className=" d-flex mt-3"
                key={`checkbox-survey-child`}
            >
                <div className="mr-2">
                    <label class="custom-checkbox-large">
                        <input
                            type="checkbox"
                            // id={`assign-checkbox-${params.row.job_id}`}
                            // key={`assign-checkbox-${params.row.job_id}`}
                            // onClick={onChange}
                            // defaultChecked={
                            //   inspector ? inspector == jobInspector : false
                            // }
                            // checked={inspector ? inspector == jobInspector : false}
                            disabled={isShow}
                            checked={watch("fire_safety_required") == true ? true : false}
                            onChange={(e) => setValue("fire_safety_required",  e.target.checked == true ? true : null )}
                        />
                        <span class="checkmark-large"></span>
                    </label>

                </div>
                <div className="mb-2">
                    <p className="eng-language-600" style={{ color: 'red'}}>The fire Safety Notice has NOT been posted or is damaged. Please have it posted on
                        my entrance door.</p>
                    <p className="span-language" style={{ color: 'red'}}>  El Aviso de Seguridad contra Incendios NO ha sido colocado o está dañado. Por favor,
                        colóquelo en la puerta de entrada de mi apartamento.</p>
                </div>
            </div>


        </>
    );
};

export default FireCompliance;
